// src/store/auth.module.js
import { defineStore } from 'pinia';
import AuthService from '@/services/auth.service';
import OAuthService from '@/services/oauth.service';
import { useUnreadStore } from '@/store/unread.module';
import { apiClient } from "@/services/auth-header";
import {USER_ROLE} from "@/common/common-enum";

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: true, user } : { loggedIn: false, user: null };

export const useAuthStore = defineStore('auth', {
    state: () => ({
        status: initialState,
    }),
    actions: {
        async login(reqDto) {
            try {
                const loggedInUser = await AuthService.login(reqDto);
                this.loginSuccess(loggedInUser);
                return Promise.resolve(loggedInUser);
            } catch (error) {
                this.loginFailure();
                return Promise.reject(error);
            }
        },
        async snsLogin(accessToken) {
            try {
                const loggedInUser = await OAuthService.login(accessToken);
                this.loginSuccess(loggedInUser);
                return Promise.resolve(loggedInUser);
            } catch (error) {
                this.loginFailure();
                return Promise.reject(error);
            }
        },
        logout() {
            AuthService.logout();
            this.logoutSuccess();
        },
        loginSuccess(user) {
            this.status.loggedIn = true;
            this.status.user = user;
            const unreadStore = useUnreadStore();
            unreadStore.fetchAllUnreadCounts();
        },
        loginFailure() {
            this.status.loggedIn = false;
            this.status.user = null;
        },
        logoutSuccess() {
            this.status.loggedIn = false;
            this.status.user = null;
        },
        async refreshRoleType() {
            const roleType = this.status.user?.roleType;
            if(!roleType || roleType === USER_ROLE.ARTIST) {
                return;
            }

            try {
                const response = await apiClient.get("/v1/auth/check-role"); //check-role  /v1/users/me
                const user = response.data;
                if(!user) return;
                localStorage.setItem('user', JSON.stringify(user));
                this.status.loggedIn = true;
                this.status.user = user;
            } catch (error) {
                error.value = error;
            }

        },
    },
    getters: {
        isAuthenticated: (state) => state.status.loggedIn,
    },
});
